import React from 'react';

import CurrencySign from 'components/price/CurrencySign.component';

import { groupProducts } from 'clientProfile/utils';

const ProductsList = (props) => (
  <div className="bh-item">
    {groupProducts(props.products).map((product) => (
      <div className="product" key={product.id}>
        <span className="name">{`${product.amount} x ${product.title}`}</span>
        <span className="price">
          <CurrencySign />
          {product.totalPrice}
        </span>
      </div>
    ))}
  </div>
);

export default ProductsList;
